<template>
	<div>
		<el-form :inline="true" >
			<el-form-item>
				<el-input
						v-model="searchForm.name"
						placeholder="名称"
						clearable
				>
				</el-input>
			</el-form-item>

			<el-form-item>
				<el-button @click="getUnitList">搜索</el-button>
			</el-form-item>

			<el-form-item>
				<el-button type="primary" @click="dialogVisible = true">新增</el-button>
			</el-form-item>
			<!-- <el-form-item>
				<el-popconfirm title="这是确定批量删除吗？" @confirm="delHandle(null)">
					<el-button type="danger" slot="reference" :disabled="delBtlStatu">批量删除</el-button>
				</el-popconfirm>
			</el-form-item> -->
		</el-form>

		<el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%;margin-top: -10px;"
				:height="tableHeight"
				border
				stripe
				@selection-change="handleSelectionChange">

			<el-table-column
					type="selection"
					width="55">
			</el-table-column>

			<el-table-column
					prop="unitCode"
					label="单位代码"
					width="120">
			</el-table-column>

			<el-table-column
					prop="unitName"
					label="单位名称"
					show-overflow-tooltip>
			</el-table-column>

			<el-table-column
					prop="endDate"
					label="截止日期"
					show-overflow-tooltip>
			</el-table-column>
			<el-table-column
					prop="remark"
					label="描述"
					show-overflow-tooltip>
			</el-table-column>

			<el-table-column
					prop="statusFlag"
					label="状态">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.statusFlag === 1" type="success">正常</el-tag>
					<el-tag size="small" v-else-if="scope.row.statusFlag === 0" type="danger">禁用</el-tag>
				</template>

			</el-table-column>
			<el-table-column
					prop="icon"
					label="操作">

				<template slot-scope="scope">
					<el-button type="text" @click="permHandle(scope.row.id)">分配权限</el-button>
					<el-divider direction="vertical"></el-divider>

					<el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
					<el-divider direction="vertical"></el-divider>

					<template>
						<el-popconfirm title="确定要重置管理员密码吗？" @confirm="resetHandle(scope.row.id)">
							<el-button type="text" slot="reference">重置密码</el-button>
						</el-popconfirm>
					</template>

					<!-- <template>
						<el-popconfirm title="确定要删除该单位吗？" @confirm="delHandle(scope.row.id)">
							<el-button type="text" slot="reference">删除</el-button>
						</el-popconfirm>
					</template> -->

				</template>
			</el-table-column>

		</el-table>


		<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[10, 20, 50, 100]"
				:current-page="current"
				:page-size="size"
				:total="total">
		</el-pagination>


		<!--新增对话框-->
		<el-dialog
				title="提示"
				:visible.sync="dialogVisible"
				width="600px"
				:before-close="handleClose"
				:close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">

				<el-form-item label="单位名称" prop="unitName" label-width="100px">
					<el-input v-model="editForm.unitName" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="单位代码" prop="unitCode" label-width="100px">
					<el-input v-model="editForm.unitCode" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="截止日期" prop="endDate" label-width="100px">
					<!-- <el-input v-model="editForm.endDate" autocomplete="off"></el-input> -->
					<el-date-picker v-model="editForm.endDate" type="date" placeholder="选择日期"></el-date-picker>
				</el-form-item>

				<el-form-item label="描述" prop="remark" label-width="100px">
					<el-input v-model="editForm.remark" autocomplete="off"></el-input>
				</el-form-item>


				<el-form-item label="状态" prop="statusFlag" label-width="100px">
					<el-radio-group v-model="editForm.statusFlag">
						<el-radio :label=0>禁用</el-radio>
						<el-radio :label=1>正常</el-radio>
					</el-radio-group>
				</el-form-item>

				<!-- <el-form-item>
					<el-button type="primary" @click="submitForm('editForm')">保存</el-button>
					<el-button @click="resetForm('editForm')">重置</el-button>
				</el-form-item> -->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog
				title="分配权限"
				:visible.sync="permDialogVisible"
				width="600px"
				height="200px"
				:close-on-click-modal="false">

			<el-form :model="permForm" >

				<el-tree
					:data="permTreeData"
					:style="{height: '370px',overflow:'auto'}"
					show-checkbox
					ref="permTree"
					node-key="id"
					:default-expanded-keys="permMenuIds"
					:props="defaultProps">
				</el-tree>

			</el-form>

			<span slot="footer" class="dialog-footer">
			    <el-button @click="permDialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="submitPermFormHandle('permForm')">确 定</el-button>
			</span>

		</el-dialog>

	</div>
</template>

<script>
	export default {
		name: "Unit",
		data() {
			return {
				searchForm: {},
				delBtlStatu: true,

				total: 0,
				size: 10,
				current: 1,

				dialogVisible: false,
				editForm: {

				},

				tableData: [],

				editFormRules: {
					unitName: [
						{required: true, message: '请输入单位名称', trigger: 'blur'}
					],
					unitCode: [
						{required: true, message: '请输入单位代码', trigger: 'blur'}
					],
					endDate: [
						{required: true, message: '请输入截止日期', trigger: 'blur'}
					],
					statusFlag: [
						{required: true, message: '请选择状态', trigger: 'blur'}
					]
				},

				multipleSelection: [],

				permDialogVisible: false,
				permForm: {},
				defaultProps: {
					children: 'children',
					label: 'menuName'
				},
				permTreeData: [],
				permMenuIds:[]
			}
		},
		computed: {
			tableHeight: function() {
				return screen.height > 900 ? 650: 550
			}
		},
		created() {
			this.getUnitList()

			this.$axios.get('/sys/menu/list').then(res => {
				this.permTreeData = res.data.data
			})
		},
		methods: {
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				console.log("勾选")
				console.log(val)
				this.multipleSelection = val;

				this.delBtlStatu = val.length == 0
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.size = val
				this.getUnitList()
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.current = val
				this.getUnitList()
			},

			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false
				this.editForm = {}
			},
			handleClose() {
				this.resetForm('editForm')
			},

			getUnitList() {
				this.$axios.get("/sys/unit/list", {
					params: {
						name: this.searchForm.name,
						current: this.current,
						size: this.size
					}
				}).then(res => {
					this.tableData = res.data.data.records
					this.size = res.data.data.size
					this.current = res.data.data.current
					this.total = res.data.data.total
				})
			},

			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$axios.post('/sys/unit/' + (this.editForm.id?'update' : 'save'), this.editForm)
							.then(res => {

								this.$message({
									showClose: true,
									message: '保存成功',
									type: 'success',
									onClose:() => {
										this.getUnitList()
									}
								});

								this.dialogVisible = false
								this.resetForm(formName)
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			editHandle(id) {
				this.$axios.get('/sys/unit/info/' + id).then(res => {
					this.editForm = res.data.data

					this.dialogVisible = true
				})
			},
			delHandle(id) {

				var ids = []

				if (id) {
					ids.push(id)
				} else {
					this.multipleSelection.forEach(row => {
						ids.push(row.id)
					})
				}

				console.log(ids)

				this.$axios.post("/sys/unit/delete", ids).then(res => {
					this.$message({
						showClose: true,
						message: '删除成功',
						type: 'success',
						onClose:() => {
							this.getUnitList()
						}
					});
				})
			},
			permHandle(id) {
				this.permDialogVisible = true

				this.$axios.get("/sys/unit/info/" + id).then(res => {

					console.log(res.data.data.menuIds)
					this.$refs.permTree.setCheckedKeys(res.data.data.menuIds)
					this.permForm = res.data.data
				})

				this.permTreeData.forEach(m=>{
					this.permMenuIds.push(m.id)
				})
			},

			submitPermFormHandle(formName) {
				var menuIds = this.$refs.permTree.getCheckedKeys()

				console.log(menuIds)

				this.$axios.post('/sys/unit/perm/' + this.permForm.id, menuIds).then(res => {
					this.$message({
						showClose: true,
						message: '保存成功',
						type: 'success',
						onClose:() => {
							this.getUnitList()
						}
					});
					this.permDialogVisible = false
					this.resetForm(formName)
				})
			},

			resetHandle(id) {
				this.$axios.post('/sys/unit/reset/' + id).then(res => {
					this.$message({
						showClose: true,
						message: '重置密码成功',
						type: 'success'
					});
				})
			}
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}
</style>